/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Apply_ActionInputs */

const en_template_apply_action = /** @type {(inputs: Template_Apply_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const de_template_apply_action = /** @type {(inputs: Template_Apply_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anwenden`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Template_Apply_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const template_apply_action = /** @type {((inputs?: Template_Apply_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Apply_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_apply_action(inputs)
	return de_template_apply_action(inputs)
});